/* This file is autogenerated, see readme.md for instructions */
import ReportSvgIcon from '@bloomreach/banana-theme/icons/report.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ReportIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ReportSvgIcon />
    </Icon>
  );
});

ReportIcon.displayName = 'ReportIcon';

export default ReportIcon;
